module.exports = new __parcel__URL__("miles.8c51c61d.jpg").toString();